var features = {}

features.browser = !(typeof window === 'undefined')

if( features.browser ){
	features.transition = document.createElement('div').style.transition !== undefined
}

export default features

features.__filename__ = 'components/features.js'
